import React, { useEffect, useRef } from "react";

const VideoDisplay = ({ mediaStream }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (videoElement) {
      if (typeof mediaStream === "string") {
        videoElement.src = mediaStream;
      } else {
        videoElement.srcObject = mediaStream;
      }
     // videoElement.play();
    }
  }, [mediaStream]);

  return (
    <div>
      <video
        ref={videoRef}
        width="100%"
        height="100%"
        controls
      >
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoDisplay;
